const validate = (values) => {
  const errors = {};

  
  // if (!values.PatientIds || !values.PatientIds.length) {
  //   errors.PatientIds = 'Please select client';
  // }
  if (!values.FromDate) {
    errors.FromDate = 'Please select from date';
  }
  if (!values.ToDate) {
    errors.ToDate = 'Please select to date';
  }
  return errors;
};
export default validate;



// WEBPACK FOOTER //
// ./src/modules/Billing/components/Ledger/validate.js